import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useState, useEffect } from 'react';
import { EMOJI_REGEX } from '@/utils/constant';

interface CancellationReasonDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
    itemType: string;
    isLoading?: boolean;
}

export const CancellationReasonDialog = ({
    open,
    onClose,
    onConfirm,
    itemType,
    isLoading,
}: CancellationReasonDialogProps) => {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (open) {
            setReason('');
        }
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
            <DialogContent className="sm:max-w-md gap-6">
                <DialogHeader>
                    <DialogTitle className="font-semibold text-lg">Cancelation Reason</DialogTitle>
                    <DialogDescription className="text-[#71717A] text-sm">
                        Please provide a reason for canceling this {itemType}.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex flex-col gap-2">
                    <Textarea
                        value={reason}
                        onChange={(e) => {
                            const filteredValue = e.target.value.replace(EMOJI_REGEX, '');
                            setReason(filteredValue.replace(/^\s+/, ''));
                        }}
                        placeholder="Type your reason here..."
                        className="min-h-[100px] resize-none"
                    />
                </div>

                <DialogFooter className="justify-end">
                    <div className="flex gap-4">
                        <Button
                            size="sm"
                            variant="outline"
                            className="bg-[#fff] border-[1px] border-bordercolor font-medium text-primary py-2 px-4 rounded-md w-24 hover:bg-[#EDF5FF]"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="sm"
                            className="bg-[#D72222] hover:bg-error text-white py-2 px-4 rounded-md w-24 font-medium"
                            onClick={() => onConfirm(reason)}
                            disabled={!reason.trim() || isLoading}
                            isLoading={isLoading}
                        >
                            Confirm
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
